import { Button, EmptyState } from '@repo/ui';

interface ServerUnreachablePageProps {
  onRetry: () => void;
}

/** A failed account lookup that is not a 401, so signing in again would not help. */
export default function ServerUnreachablePage({ onRetry }: ServerUnreachablePageProps) {
  return (
    <div className="flex h-full items-center justify-center px-4">
      <EmptyState
        title="Cannot reach the server"
        description="Your account could not be loaded. Try again in a moment."
        action={
          <Button variant="outline" onClick={onRetry}>
            Retry
          </Button>
        }
      />
    </div>
  );
}
